import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import localforage from 'localforage';

import isElectron from '../utils/is-electron.js';

import * as sessionActions from '../actions/session-actions';
import * as popoverActions from '../actions/popover-actions';
import * as friendsActions from '../actions/friends-actions';
import * as roomsActions from '../actions/rooms-actions';
import * as notificationsActions from '../actions/notifications-actions';

import { PopoverTypes } from '../reducers/popover-reducer'

import Header from '../components/Header.js';
import ProfilePopover from '../components/ProfilePopover.js';
import NotificationsPopover from '../components/NotificationsPopover.js';
import './AppContainer.css';

class AppContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showingNotificationPopover: false,
      showingProfilePopover: false
    };
  }

  /**
   * App has been logged in! Fetch friends, notifications, and
   * rooms for the current user to populate the welcome page.
   *
   * @memberof AppContainer
   */
  componentDidMount() {
    const { friendsActions, roomsActions, notificationsActions, session } = this.props;

    friendsActions.requestFriendsList();
    roomsActions.requestRoomsList();
    notificationsActions.requestNotificationList();

    // Poll for notifications every 10 seconds.
    this.notificationPoll = setInterval(() => this.refreshNotifications(), 10000);

    // Check the users' last-set availability, and update their availability with it (or default
    // to Available if it doesn't exist).
    localforage.getItem('availability')
      .then((availability) => {
        this.onUpdateAvailability(availability || 1);
      });
  }

  componentWillUnmount() {
    clearInterval(this.notificationPoll);
  }

  onUpdateAvailability = (newAvailability) => {
    if (!isElectron()) {
      // If we're not currently in Electron, don't try to update availability.
      return;
    }

    let ipcRenderer = window.require('electron').ipcRenderer;
    const { session } = this.props;

    let payload = {
      user: session.user.id,
      authToken: session.token,
      availability: newAvailability
    };

    localforage.setItem('availability', newAvailability);
    ipcRenderer.send('set-online-status', payload)
  }

  refreshNotifications = () => {
    const { notificationsActions, friendsActions } = this.props;
    notificationsActions.requestNotificationList();
    friendsActions.requestFriendsList();
  }

  componentWillReceiveProps(nextProps) {
    const { friendsActions, roomsActions, notifications } = this.props;

    // If a new notification has been received (or one has been accepted/declined),
    // update the users rooms and friends lists.
    if (notifications.notifications.length !== nextProps.notifications.notifications.length) {
      setTimeout(() => {
        friendsActions.requestFriendsList();
        roomsActions.requestRoomsList();
      }, 250);
    }
  }

  toggleNotificationPopover = () => {
    if (this.props.popovers.openPopover === PopoverTypes.Notification) {
      this.props.popoverActions.closePopover();
      return;
    }

    this.props.popoverActions.openPopover(PopoverTypes.Notification);
  }

  toggleProfilePopover = () => {
    if (this.props.popovers.openPopover === PopoverTypes.Profile) {
      this.props.popoverActions.closePopover();
      return;
    }

    this.props.popoverActions.openPopover(PopoverTypes.Profile);
  }

  closePopovers = () => {
    if (this.props.popovers.openPopover) {
      this.props.popoverActions.closePopover();
    }
  }

  render() {
    const { popovers, notifications, notificationsActions } = this.props;
    const { openPopover } = popovers;
    const { showingNotificationPopover, showingProfilePopover } = this.state;

    // Set flags for determining when a popover is visible or not.
    let profilePopoverVisible, notificationPopoverVisible;
    switch(this.props.popovers.openPopover) {
      case PopoverTypes.Profile:
        profilePopoverVisible = true;
        break;
      case PopoverTypes.Notification:
        notificationPopoverVisible = true;
        break;
    }

    // Build variables for the profile popover and notification popover instance,
    // passing in whether the popover is currently visible or not.
    let profilePopover = <ProfilePopover user={this.props.session.user}
      visible={profilePopoverVisible}
      close={this.toggleProfilePopover}
      onUpdateAvailability={this.onUpdateAvailability} />;

    let notificationPopover = <NotificationsPopover notifications={notifications.notifications}
      visible={notificationPopoverVisible}
      acceptNotification={notificationsActions.acceptNotification}
      declineNotification={notificationsActions.declineNotification} />;

    return (
      <div className="AppContainer">
        <Header
          notificationCount={notifications.notifications.length}
          notificationPopover={notificationPopover}
          notificationPopoverVisible={notificationPopoverVisible}
          toggleNotificationPopover={this.toggleNotificationPopover}

          profilePopover={profilePopover}
          profilePopoverVisible={profilePopoverVisible}
          toggleProfilePopover={this.toggleProfilePopover}

          closePopovers={this.closePopovers} />

        {this.props.children}
      </div>
    )
  }
}

function mapStateToProps(state, props) {
  return {
    session: state.session,
    popovers: state.popover,
    friends: state.friends,
    notifications: state.notifications
  };
};

function mapDispatchToProps(dispatch) {
  return {
    sessionActions: bindActionCreators(sessionActions, dispatch),
    popoverActions: bindActionCreators(popoverActions, dispatch),
    friendsActions: bindActionCreators(friendsActions, dispatch),
    roomsActions: bindActionCreators(roomsActions, dispatch),
    notificationsActions: bindActionCreators(notificationsActions, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AppContainer);



// WEBPACK FOOTER //
// ./src/containers/AppContainer.js